import React, { Component } from 'react'
import { TextField, InputAdornment } from '@material-ui/core'
import DialpadIcon from '@material-ui/icons/Dialpad'

export class PhoneNumber extends Component {
  render() {
    return (
      <TextField
        style={{
          margin: '6px'
        }}
        label="Phone Number"
        name="phonenumber"
        value={(this.props.phonenumber && this.props.phonenumber) || ''}
        id="phonenumber"
        placeholder="9665xxxxxxxx"
        margin="dense"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <DialpadIcon fontSize="small" className="icon-color" />
            </InputAdornment>
          )
        }}
        className="text-field-style"
        variant="outlined"
        autoComplete="false"
        onChange={this.props.onChange}
        required
      />
    )
  }
}

export default PhoneNumber
